import {
  LOGIN_USER,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
} from "./actionTypes"

const initialState = {
  userData: null, // To store logged-in user info
  error: "",
  loading: false,
  isUserLogout: false, // To manage logout state
}

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        loading: true,
        error: "", // Clear any previous errors
      }

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isUserLogout: false,
        userData: action.payload,
      }

    case LOGOUT_USER:
      return { ...state }

    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        isUserLogout: true,
        userData: null, // Clear user info on logout
      }

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        isUserLogout: false,
      }

    default:
      return state
  }
}

export default login
